import { useMutation } from '@apollo/client';
import {
  VerifyUnauthenticatedUploaderAvailabilityProps,
  VERIFY_UNAUTHENTICATED_UPLOADER_AVAILABILITY,
} from 'src/commons/api/graphql/mutations';

type VerifyUnauthenticatedUploaderProps = {
  uuid: string;
};

export default function useVerifyUnauthenticatedUploaderAvailability({
  onCompleted,
  onError,
}) {
  const [
    execute,
    { error, data, loading },
  ] = useMutation<VerifyUnauthenticatedUploaderAvailabilityProps>(
    VERIFY_UNAUTHENTICATED_UPLOADER_AVAILABILITY,
    {
      onCompleted,
      onError,
      fetchPolicy: 'no-cache',
    },
  );

  const verifyUnauthenticatedUploaderAvailability = ({
    uuid,
  }: VerifyUnauthenticatedUploaderProps) => {
    execute({
      variables: {
        uuid,
      },
    });
  };

  return {
    verifyUnauthenticatedUploaderAvailability,
    error,
    data: data?.verifyUnauthenticatedUploaderAvailability,
    loading,
  };
}
